import React, { useState, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { LoadingContainer } from '../LoadingContainer';
import Grid from '@mui/material/Grid';
import { useNotify } from '@lifeomic/phc-web-toolkit/src/hooks/useNotify';
import { MarkdownCell } from './MarkdownCell';
import { CodeCell } from './CodeCell';
import _get from 'lodash/get';

const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  content: {
    width: '100%',
    padding: theme.spacing(1),
  },
}));

const messages = defineMessages({
  fetchNotebookToast: {
    id: 'notebooks.notifications.fetchErrorToast',
    defaultMessage: 'An error occurred when fetching the notebook',
  },
});

const Cell = ({ cell, language, showCode }) => {
  if (cell.cell_type === 'markdown') {
    return <MarkdownCell cell={cell} />;
  } else if (cell.cell_type === 'code') {
    return <CodeCell cell={cell} language={language} showCode={showCode} />;
  } else {
    return <div></div>;
  }
};

export const Notebook = ({ file, showCode }) => {
  const classes = useStyles({});
  const { formatMessage } = useIntl();
  const [notebookData, setNotebookData] = useState(null);
  const [addNote] = useNotify();
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    const fetchNotebook = async () => {
      try {
        const res = await fetch(file.downloadUrl);
        const json = await res.json();
        setNotebookData(json);
      } catch (error) {
        console.error('Error fetching notebook', error);
        addNote(formatMessage(messages.fetchNotebookToast), 'error');
      } finally {
        setIsLoading(false);
      }
    };

    fetchNotebook();
  }, [file.downloadUrl, addNote, formatMessage]);

  return (
    <React.Fragment>
      {isLoading ? (
        <LoadingContainer />
      ) : (
        <Grid item xs={12} container className={classes.content}>
          {(notebookData.cells || []).map((cell, index) => (
            <Cell
              key={index}
              cell={cell}
              showCode={showCode}
              language={_get(
                notebookData,
                'metadata.kernelspec.language',
                'python',
              )}
            />
          ))}
        </Grid>
      )}
    </React.Fragment>
  );
};
